import Route from 'mewe/routes/route';
export default Route.extend({
  theme: 'group',
});
